import { useAppQuery } from "../../querys/useAppQuery";
import { AxiosError } from "axios";
import { IErrorResponse, QueryKeys } from "../../querys/querys.enum";
import axiosInstance from "../../../utils/axios";
import { NotificationManagementsResponse } from "../../../models/Interface/NotificationManagement.interface";

/** GET /notifications-management — permission: `get:all:notification:managements` */
const useNotificationManagements = () => {
  return useAppQuery<
    NotificationManagementsResponse,
    AxiosError<IErrorResponse>
  >({
    queryKey: [QueryKeys.NOTIFICATION_MANAGEMENTS],
    queryFn: async () => {
      return (await axiosInstance.get(`/notifications-management`)).data;
    },
    enabled: true,
    retry: 0,
  });
};

export default useNotificationManagements;
